import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfFacebookIconProps extends SvgIconProps  { }

/**
 * Component to display facebook icon
 * @param props -CcfFacebookIconProps
 * @returns svg icon of facebook
 * @example <CcfFacebookIcon/>
 */
export function CcfFacebookIcon(props: CcfFacebookIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_Facebook_Public">
        <g id="Channel_Type" data-name="Channel Type" transform="translate(3.5 3.551)">
          <g id="Icon_Interaction_Type" data-name="Icon Interaction Type">
            <path id="Path_12742" data-name="Path 12742" d="M17,8.5a8.5,8.5,0,1,0-9.828,8.4v-5.94H5.014V8.5H7.172V6.627A3,3,0,0,1,10.383,3.32a13.073,13.073,0,0,1,1.9.166V5.578H11.213A1.228,1.228,0,0,0,9.828,6.906V8.5h2.357l-.377,2.457H9.828V16.9A8.5,8.5,0,0,0,17,8.5Z" fill="#3b5998" />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfFacebookIcon;
